"use strict";

/* -------------------------------------------------------------------------

	PUNITED.utils

	Define utility functionalities
	Implementation only uses standard, modern JavaScript features, free of jQuery dependency
	Potential United inc.

------------------------------------------------------------------------- */
// グローバル名前空間定義
var PUNITED;
if (!PUNITED) PUNITED = {};
if (!PUNITED.utils) PUNITED.utils = {};

(function () {
  // グローバル名前空間オブジェクトをローカルオブジェクトに置き換え
  var ns = PUNITED.utils;
  /* -----------------------------------------------------
      Accordion
      Base off of HTML <details> tag
  ----------------------------------------------------- */

  ns.accordion = function () {
    var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.accordion';
    var openClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '--open';
    var items = document.querySelectorAll(selector);
    items.forEach(function (item) {
      item.addEventListener('toggle', handleToggle);
    });

    function handleToggle(e) {
      e.currentTarget.classList.toggle(openClass, e.open);
    }
  };

  ns.accordionImproved = function (selector) {
    var details = document.querySelectorAll(selector);
    var MOVING_VALUE = "moving"; // アニメーション実行中のときに付与する予定のカスタムデータ属性の値

    var IS_OPENED_CLASS = "--open"; // アイコン操作用のクラス名

    details.forEach(function (element) {
      var head = element.querySelector("summary");
      var content = element.querySelector("summary + *");
      var icon = element.querySelector(".opener");
      element.addEventListener('toggle', function (e) {
        if (e.newState === 'open') {
          icon.classList.add(IS_OPENED_CLASS);
        }
      });
      head.addEventListener("click", function (event) {
        // デフォルトの挙動を無効化
        event.preventDefault(); // 連打防止用。アニメーション中だったらクリックイベントを受け付けないでリターンする

        if (element.dataset.animStatus === MOVING_VALUE) {
          return;
        } // detailsのopen属性を判定


        if (element.open) {
          // アコーディオンを閉じるときの処理
          // アイコン操作用クラスを切り替える(クラスを取り除く)
          element.classList.remove(IS_OPENED_CLASS);
          icon.classList.remove(IS_OPENED_CLASS); // アニメーションを実行

          var closingAnim = content.animate(closingAnimKeyframes(content), animTiming); // アニメーション実行中用の値を付与

          element.dataset.animStatus = MOVING_VALUE; // アニメーションの完了後に

          closingAnim.onfinish = function () {
            // open属性を取り除く
            element.removeAttribute("open"); // アニメーション実行中用の値を取り除く

            element.dataset.animStatus = "";
          };
        } else {
          // アコーディオンを開くときの処理
          // open属性を付与
          element.setAttribute("open", "true"); // アイコン操作用クラスを切り替える(クラスを付与)

          element.classList.add(IS_OPENED_CLASS);
          icon.classList.add(IS_OPENED_CLASS); // アニメーションを実行

          var openingAnim = content.animate(openingAnimKeyframes(content), animTiming); // アニメーション実行中用の値を入れる

          element.dataset.animStatus = MOVING_VALUE; // アニメーション完了後にアニメーション実行中用の値を取り除く

          openingAnim.onfinish = function () {
            element.dataset.animStatus = "";
          };
        }
      });
    });
    /**
     * アニメーションの時間とイージング
     */

    var animTiming = {
      duration: 250,
      easing: 'ease'
    };
    /**
     * アコーディオンを閉じるときのキーフレーム
     */

    var closingAnimKeyframes = function closingAnimKeyframes(content) {
      return [{
        height: content.offsetHeight + 'px',
        // height: "auto"だとうまく計算されないため要素の高さを指定する
        opacity: 1
      }, {
        height: 0,
        opacity: 0
      }];
    };
    /**
     * アコーディオンを開くときのキーフレーム
     */


    var openingAnimKeyframes = function openingAnimKeyframes(content) {
      return [{
        height: 0,
        opacity: 0
      }, {
        height: content.offsetHeight + 'px',
        opacity: 1
      }];
    };
  };
  /* -----------------------------------------------------
      Anchor menu
      CSS: .anchor_menu
  ----------------------------------------------------- */


  ns.anchorMenu = function () {
    var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.anchor_menu_item > .link';
    var links = document.querySelectorAll(selector);
    links.forEach(function (link) {
      var href = link.getAttribute('href');

      if (!href.startsWith('#')) {
        return;
      }

      var id = href.replace('#', '');
      var target = document.getElementById(id);

      if (!target) {
        return;
      }

      init(link, href, target);
    });

    function init(link, href, target) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        target.scrollIntoView({
          behavior: 'smooth'
        });
        window.history.pushState({}, '', href);
      });
    }
  };
  /* -----------------------------------------------------
  Interview slider
  ----------------------------------------------------- */


  ns.interviewSlider = function () {
    var activeClass = '--active';
    var progressBar = document.querySelector('.interview_slider_progress');
    var descList = document.querySelectorAll('.interview_slider_desc_item');
    new Swiper('#interview_slider', {
      loop: true,
      autoplay: true,
      centeredSlides: true,
      slidesPerView: 3,
      navigation: {
        prevEl: '.interview_slider_prev',
        nextEl: '.interview_slider_next'
      },
      effect: 'creative',
      creativeEffect: {
        limitProgress: 2,
        prev: {
          translate: ['calc(-109.6%)', '34%', 0],
          rotate: [0, 0, -10]
        },
        next: {
          translate: ['calc(109.6%)', '34%', 0],
          rotate: [0, 0, 10]
        }
      },
      breakpoints: {
        680: {
          creativeEffect: {
            prev: {
              translate: ['calc(-120%)', '20%', 0]
            },
            next: {
              translate: ['calc(120%)', '20%', 0]
            }
          }
        }
      },
      on: {
        slideChange: function slideChange(swiper) {
          var index = swiper.realIndex;
          var progress = (index + 1) / swiper.slides.length * 100;
          progressBar.style.setProperty('--interview-slider-progress', "".concat(progress, "%"));
          descList.forEach(function (desc, i) {
            if (i === index) {
              desc.classList.add(activeClass);
            } else {
              desc.classList.remove(activeClass);
            }
          });
        }
      }
    });
    ns.refreshScrollTriggerPosition();
  };
  /* -----------------------------------------------------
      .bottom_slider
  ----------------------------------------------------- */


  ns.bottomSlider = function () {
    var container = document.querySelector('.bottom_slider');
    var slider = container.querySelector('.swiper');
    var slides = container.querySelectorAll('.swiper-slide');
    var prev = container.querySelector('.bottom_slider_prev');
    var next = container.querySelector('.bottom_slider_next');
    var progressBar = container.querySelector('.bottom_slider_progress');
    var isRect = container.classList.contains('--rectangle');
    var swiper = null;
    init();
    PUNITED.common.mediaQuery.addEventListener('change', function () {
      destroy();
      init();
    });

    function init() {
      var options = {
        loop: true,
        autoplay: getAutoplay(),
        allowTouchMove: false,
        centeredSlides: true,
        slidesPerView: getSlidesPerView(),
        spaceBetween: getSpaceBetween(),
        navigation: {},
        on: {
          afterInit: transformSlides,
          slideChangeTransitionStart: transformSlides
        }
      };

      if (prev) {
        options.navigation.prevEl = prev;
      }

      if (next) {
        options.navigation.nextEl = next;
      }

      if (progressBar) {
        options.on.slideChange = function (swiper) {
          var index = swiper.realIndex;
          var progress = (index + 1) / swiper.slides.length * 100;
          progressBar.style.setProperty('--interview-slider-progress', "".concat(progress, "%"));
        };
      }

      swiper = new Swiper(slider, options);
      ns.refreshScrollTriggerPosition();
    }

    function destroy() {
      var _swiper;

      (_swiper = swiper) === null || _swiper === void 0 ? void 0 : _swiper.destroy();
      swiper = null;
    }

    function getAutoplay() {
      var slidesPerView = getSlidesPerView();
      return slides.length > slidesPerView;
    }

    function getSlidesPerView() {
      return PUNITED.common.mediaQuery.matches ? 3 : 5;
    }

    function getSpaceBetween() {
      return PUNITED.common.mediaQuery.matches ? 20 : 30;
    }

    function transformSlides(swiper) {
      var y = 60;

      if (isRect) {
        y *= -1;
      }

      swiper.slides.forEach(function (slide) {
        if (slide.classList.contains('swiper-slide-next') || slide.classList.contains('swiper-slide-prev')) {
          slide.style.transform = "translate3d(0, ".concat(swiper.swipeDirection === 'next' ? 0 : y, "px, 0)");
        } else {
          slide.style.transform = "translate3d(0, ".concat(swiper.swipeDirection === 'next' ? y : 0, "px, 0)");
        }
      });
    }
  };
  /* -----------------------------------------------------
      Call this in a page where slider is used.
      Slider initialization screws up any scroll trigger instances that initialize before it.
      So, force all scroll trigger instances to recalculate their positions after a slider is initialized.
        If not done so, any animated elements that depend on scroll trigger below slider may not get triggered
      and may not be visible.
  ----------------------------------------------------- */


  ns.refreshScrollTriggerPosition = function () {
    ScrollTrigger.refresh();
  };
})();